// Master-rajapinta. Erillinen asiakassovelluksen api.ts:stä, koska 401 ei saa
// ohjata asiakkaan kirjautumissivulle — master hoitaa kirjautumisen itse.

export class MasterError extends Error {}

export async function mapi<T = unknown>(
  path: string,
  method: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE' = 'GET',
  body?: unknown,
): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new MasterError((data as { error?: string }).error || res.statusText);
  return data as T;
}
